<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">
          <div>
            <img src="assets/images/history/foundingdocument.png" alt="Founding Documents" class="hero-header-img">
          </div>

          <div class="right-menu">
            <mat-form-field appearance="fill">
              <mat-label>Tools...</mat-label>
              <mat-select (selectionChange)="onRouteSelect($event.value)">
                @for (routeOption of delegateroutes; track routeOption) {
                <mat-option [value]="routeOption.path">
                  {{ routeOption.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <h4><b>Party Resource Documents</b></h4>

          <p>It starts with understanding the party platform, which descibes the moral and ethical positions of the
            party.
          </p>
          <p>The <a href="assets/pdf/RNCPlatform-2020.pdf">Republican Party Platform</a> is the document that unites the
            party with the moral ideas worth fighting for.
          </p>

        </div>

        <div class="col-12-large ">

          <h5><b>Delegate Documents</b></h5>

          <p>The following links are the documents needed to get on the ballot to be elected. A delegate can get on the
            ballot by filing on time with the county clerk, or by being a write-in on election day.
          </p>

          <p><a
              href="https://www.michigan.gov/sos/-/media/Project/Websites/sos/25delrio/Aff-ID_Precnt_139901_7.pdf">Affidavit
              of Identity PDF</a></p>
          <p><a
              href="https://www.michigan.gov/sos/-/media/Project/Websites/sos/25delrio/Dec-Int-Write-In_94360_7.pdf">Delegate
              Write In</a></p>


          <blockquote class="doc-quotes">
            <p>"There can be no truer principle than this—that every individual of the community at large has an equal
              right to the protection of government."
              -Alexander Hamilton, Speech at Constitutional Convention, June 29, 1787</p>
          </blockquote>

          <h5><b>Robert's Rules For Delegate Meetings</b></h5>

          <p>
            The following cheatsheet and meeting toolkit will help you and your fellow delgates have productive
            meetings.
          </p>
          <p>Robert's Rules of Order have the sole purpose of productivity for a group, and are most effective when the
            entire group knows them well.</p>
          <p>If only a few know the rules, then those who do not will will be subservient to those who do. </p>
          <p>Learn them well. They are the rules of the party.</p>

          <p><a href="/assets/pdf/RONRMeetingCheatsheet.pdf">RONR Cheatsheet</a></p>
          <p><a href="/assets/pdf/RONRMotionPrecedence.pdf">RONR Precedence Chart</a></p>

          <blockquote class="doc-quotes">
            <p>"Justice is indiscriminately due to all, without regard to numbers, wealth, or rank."
              -John Jay, in Georgia v. Brailsford, 1794</p>
          </blockquote>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 2 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5><b>Michigan State Republican Party Documents</b></h5>

          <p>The following documents govern participation at the state level.
          </p>

          <p><a href="/assets/pdf/MRSC-Bylaws-r12-2022.pdf">Michigan Republican Party Bylaws 2022</a></p>
          <p><a href="/assets/pdf/State-Selection-and-Convention-Rules-Updated-2-11-23.pdf">State Convention Rules -
              Leadership Election</a></p>
          <p><a href="/assets/pdf/2024-Spring-County-and-District-Conventions.pdf">State Convention Rules - Election of
              Delegates to National Convention</a></p>
          <p><a href="/assets/pdf/Nominating-Convention-Rules-08-2022.pdf">State Convention Rules - Nomination</a></p>
          <p><a href="/assets/pdf/April-2022-County-Convention-Rules.pdf">State Convention Rules - Endorsement</a></p>


          <blockquote class="doc-quotes">
            <p>"Without liberty, law loses its nature and its name, and becomes oppression. Without law, liberty also
              loses its nature and its name, and becomes licentiousness." - James Wilson, Of the Study of the Law in the
              United States, 1790</p>
          </blockquote>


        </div>

        <div class="col-12-large ">

          <h5><b>National Constitution, State Law and State Constitution</b></h5>

          <p>
            The following are our state laws, state constitution, as well as the national constitution to guide our
            endeavors.
          </p>
          <p><a href="https://constitutioncenter.org/interactive-constitution/full-text">United States Constitution</a>
          </p>
          <p><a href="https://www.legislature.mi.gov/Publications/MIConstitution.pdf">Michigan State Constitution</a>
          </p>
          <p><a
              href="https://www.legislature.mi.gov/(S(aancjxc0ekemc4lpafe4wspx))/mileg.aspx?page=MCLBasicSearch">Michigan
              Compiled Laws</a></p>
          <p><a
              href="https://www.legislature.mi.gov/(S(dq21k3pbhi25n2bmxqrn1ikq))/mileg.aspx?page=getObject&objectName=mcl-chap168">Michigan
              Election Law MCL 168</a></p>

          <blockquote class="doc-quotes">
            <p>"The powers not delegated to the United States by the Constitution, nor prohibited by it to the States,
              are reserved to the States respectively, or to the people." - Tenth Amendment, 1791</p>
          </blockquote>


        </div>

      </div>
    </div>
  </div>
</section>

<!-- END OF PAGE ----------------------------------------------------------------------------------------------- -->